export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/chris-karidisz-141e54b59af43b1eb798f2a9b51f2676.jpg";